import React from 'react';
import { MOCKUP_IMAGE, OFFER_ANCHOR, PRODUCT } from '../data/constants';
interface MockupImageProps {
  className?: string;
  priority?: boolean;
}
export function MockupImage({
  className,
  priority = false
}: MockupImageProps) {
  return <a href={OFFER_ANCHOR} aria-label={`Voir l’offre ${PRODUCT}`} className={`block ${className ?? ''}`} data-id="element-110" data-mp="2vtq3f28g7n3a">
      <img src={MOCKUP_IMAGE} alt={`${PRODUCT} — système complet 6 en 1 : interprétation électrocardiographique et rythmes cardiaques`} loading={priority ? 'eager' : 'lazy'} className="mx-auto w-full max-w-[340px] drop-shadow-xl sm:max-w-md" data-id="element-111" data-mp="2mumn260o1lsh" />
    </a>;
}